<form class="list-work-order-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Disable Validations</h3>
    </div>
  </div>

  <app-flag-on-off-filter [filterFormGroup]="filterFormGroup"></app-flag-on-off-filter>
  <app-flag-on-off-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-flag-on-off-grid>
</form>
